import styled from "styled-components"

const BurgerSpan = styled.span`
  background: ${(props) => props.theme.d_color_gradients.d_dark};
`

const LogoSite = styled.div`
  & svg,
  & path {
    fill: ${(props) => props.theme.c_color_gradients.c_dark}!important;
  }
`

export { BurgerSpan, LogoSite }
